import { StaticJsonRpcProvider } from '@ethersproject/providers'
import { ChainId } from '@nominex/nomiswap-sdk'
import { getDefaultNodeUrl } from './getRpcUrl'

// Create providers with explicit network configuration to avoid network detection errors
// Only for the 3 supported networks: BSC, Ethereum, and Polygon
export const staticProvider: Record<ChainId, StaticJsonRpcProvider> = {
  [ChainId.BSC]: new StaticJsonRpcProvider(getDefaultNodeUrl(ChainId.BSC), {
    chainId: ChainId.BSC,
    name: 'bnb',
  }),
  [ChainId.ETHEREUM]: new StaticJsonRpcProvider(getDefaultNodeUrl(ChainId.ETHEREUM), {
    chainId: ChainId.ETHEREUM,
    name: 'homestead',
  }),
  [ChainId.MATIC]: new StaticJsonRpcProvider(getDefaultNodeUrl(ChainId.MATIC), {
    chainId: ChainId.MATIC,
    name: 'matic',
  }),
} as Record<ChainId, StaticJsonRpcProvider>
